<script setup>
import { inject, ref } from 'vue'
import FiltersBase from './FiltersBase.vue'
import NoticeBoardGrid from './NoticeBoardGrid.vue'

const dataset = inject('dataset')

const filters = ref({ search: '' })
const counter = ref({
  present: true,
  past: true,
})
</script>

<template>
  <div>
    <FiltersBase v-model="filters" />

    <NoticeBoardGrid
      v-if="dataset.apiPresent"
      v-bind="{ filters, api: dataset.apiPresent }"
      v-model="counter.present"
    />

    <NoticeBoardGrid
      v-if="dataset.apiPast"
      v-bind="{ filters, api: dataset.apiPast }"
      v-model="counter.past"
    />

    <h3 class="is-size-4 pt-5" v-if="!counter.past && !counter.present">
      Nu există rezultate pentru această selecție.
    </h3>
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

:deep(.notice-board-index:not(:last-child)) {
  border-bottom: 1px solid $border;
  margin-bottom: 64px;
  padding-bottom: 64px;
}
</style>
